<template>
  <section class="ead-public-page section">
    <div class="container validar-container">
      <header class="box ead-hero">
        <div>
          <p class="ead-eyebrow">Autenticidade do documento</p>
          <h1 class="title is-3 mb-2">Validar certificado</h1>
          <p class="ead-lead">Digite o código impresso no certificado para conferir sua autenticidade.</p>
        </div>
        <span class="hero-icon" aria-hidden="true"><b-icon icon="certificate-outline" size="is-large" /></span>
      </header>

      <div class="box validar-card">
        <form @submit.prevent="validar">
          <b-field label="Código de validação" message="O código aparece no certificado emitido pela área de treinamentos.">
            <b-input v-model.trim="codigo" required maxlength="64" icon="magnify" placeholder="Digite ou cole o código" />
          </b-field>
          <b-button native-type="submit" type="is-primary" icon-left="check-decagram-outline" :loading="loading" expanded>
            Validar certificado
          </b-button>
        </form>
      </div>

      <div v-if="certificado" class="box resultado-validacao" role="status">
        <span class="resultado-icone"><b-icon icon="check-decagram" size="is-medium" /></span>
        <div>
          <p class="ead-eyebrow">Autenticidade confirmada</p>
          <h2 class="title is-5 mb-2">Certificado válido</h2>
          <p><strong>{{ certificado.nomeFuncionario }}</strong> concluiu <strong>{{ certificado.nomeCurso }}</strong> em {{ formatarData(certificado.dataConclusao) }}.</p>
        </div>
      </div>
      <div v-else-if="erro" class="box erro-validacao" role="alert">
        <b-icon icon="alert-circle-outline" />
        <p>Não foi possível validar este código. Confira os caracteres e tente novamente.</p>
      </div>
    </div>
  </section>
</template>

<script>
import http from '@/http'

export default {
  name: 'EadValidarCertificado',
  data: () => ({ codigo: '', certificado: null, loading: false, erro: false }),
  mounted() {
    if (this.$route.params.codigo) {
      this.codigo = this.$route.params.codigo
      this.validar()
    }
  },
  methods: {
    formatarData(data) {
      return new Date(data).toLocaleDateString('pt-BR')
    },
    validar() {
      if (!this.codigo.trim()) return
      this.loading = true
      this.certificado = null
      this.erro = false
      http.get(`/api/ead-certificados/validar/${encodeURIComponent(this.codigo.trim())}`)
        .then((r) => { this.certificado = r.data })
        .catch(() => { this.erro = true })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style scoped>
.validar-container { max-width: 760px; }
.hero-icon { align-items: center; background: #e5f5ef; border-radius: 18px; color: #008f7c; display: inline-flex; flex: 0 0 4.5rem; height: 4.5rem; justify-content: center; }
.validar-card { padding: 1.5rem; }
.validar-card .button { margin-top: 1.5rem; }
.resultado-validacao, .erro-validacao { align-items: flex-start; display: flex; gap: 1rem; margin-top: 1rem; padding: 1.5rem; }
.resultado-validacao { background: #f2fbf5; border-color: #b8ddc5; }
.resultado-icone { color: #2d8451; }
.erro-validacao { background: #fff7f3; border-color: #efc7b7; color: #944e36; }
@media screen and (max-width: 768px) { .ead-public-page { padding: 0.75rem; } .hero-icon { display: none; } }
</style>
